export default __webpack_public_path__ + "static/media/Single_Bow_Thruster_Transversal.a052df08.png";